// Breadcrumb dinâmico: telas com rota parametrizada (ex.: /billing/client/:id)
// publicam a trilha aqui e o Header consome enquanto o path bater.
let atual = null;
const subs = new Set();

export function setBreadcrumb(path, trail) {
  atual = { path, trail };
  subs.forEach((fn) => fn(atual));
}

export function clearBreadcrumb() {
  atual = null;
  subs.forEach((fn) => fn(atual));
}

export function getBreadcrumb() {
  return atual;
}

export function subscribeBreadcrumb(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}
